import { onReady } from './utils/on-ready';

export class RandomizeImages {
    constructor() {
        onReady(this.initialize);
    }

    initialize = () => {
        this.getRandomImages();
    }


    getRandomImages = () => {
        const imageElements = document.querySelectorAll('.randomize-images');
        imageElements.forEach(imageElement => {
            const imageData = imageElement.getAttribute('data-images');
            let images = imageData != null && imageData !== "" ? JSON.parse(imageData) : null;

            let image = images != null ? this.pickImage(images) : null;

            if (image != null) {
                imageElement.src = image.Url;
                imageElement.title = image.Title;
                imageElement.alt = image.AlternativeText;
                imageElement.height = image.Height;
                imageElement.width = image.Width;
            }
        });
    }

    pickImage = (images) => {
        const storageId = 'lastUsedImage';
        const lastUsedIdString = window.localStorage[storageId];
        let validImages = null;

        // remove last used image if exists and there are multiple images
        if (lastUsedIdString !== null && lastUsedIdString !== "undefined" && images.length > 1)
            validImages = images.filter(i => i.Id != lastUsedIdString);

        const randomNum = Math.floor(Math.random() * validImages.length);

        //set current image Id as the last know image
        window.localStorage.setItem('lastUsedImage', validImages[randomNum].Id);

        return validImages[randomNum];
    }
}
